import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { GoPortin, validatePhone } from "../../services/api";
import {
  countDay,
  notification,
  transactionID,
  validCnpj,
  validCpf,
} from "../../services/helpers";
import Loading from "../Loading/Loading";

const FormPortability = () => {
  const [newNumber, setNewNumber] = useState("");
  const [oldNumber, setOldNumber] = useState("");
  const [operator, setOperator] = useState("");
  const [cpf, setCpf] = useState("");
  const [name, setName] = useState("");
  const [opacity, setOpacity] = useState(false);
  const [load, setLoad] = useState(0);

  const opacity1 = opacity ? "opacity" : "";

  function handlePortinCall(e) {
    e.preventDefault();
    setLoad(1);
    setOpacity(true);
    if (
      newNumber === "" ||
      oldNumber === "" ||
      operator === "" ||
      cpf === "" ||
      name === ""
    ) {
      notification("error", "Preencha todos os campos");
      setLoad(0);
      setOpacity(false);
      return;
    }
    if (cpf.length <= 11) {
      if (cpf.length <= 11 && validCpf(cpf) === false) {
        notification("error", "CPF inválido");
        setLoad(0);
        setOpacity(false);

        return;
      }
    } else {
      if (cpf.length >= 12 && validCnpj(cpf) === false) {
        notification("error", "CNPJ inválido");
        setLoad(0);
        setOpacity(false);

        return;
      }
    }

    validatePhone("Correios", newNumber)
      .then((res) => {
        if (res.data.code === "00" || res.data.code === "04") {
          // console.log(res.data.accessToken);
          finishPortin(res.data.accessToken);
          return;
        } else {
          notification("error", res.data.msg);
          console.log("validatePhone: ", res.data);
          setLoad(0);
          setOpacity(false);
          return;
        }
      })
      .catch((error) => {
        notification(
          "error",
          "Ops...! Não foi possivel processar sua solicitação"
        );
        console.log("validatePhone: ", error);
        setLoad(0);
        setOpacity(false);
        return;
      });
  }

  const finishPortin = (token) => {
    GoPortin(
      transactionID("GFP"),
      newNumber,
      oldNumber,
      cpf,
      operator,
      countDay(2),
      name,
      token
    )
      .then((response) => {
        console.log(response);
        notification(
          "success",
          response.data.code === "P0001" ?
            "Você receberá um link por SMS no número que deseja manter. Acesse o link e clique em CONFIRMAR para finalizar seu pedido de portabilidade." :
            response.data.description,
          "Solicitação enviada, agora é só aguardar!"
        );
        setLoad(0);
        setOpacity(false);
        return;
      })
      .catch((error) => {
        console.log(error);
        notification("error", error.data.description);
        setLoad(0);
        setOpacity(false);
      });
  };

  return (
    <form onSubmit={(e) => handlePortinCall(e)} className="new_form_portability">
      <Loading loading={load} />
      <fieldset>
        <label htmlFor="newNumber">Número Correios Celular</label>
        <NumberFormat
          id="newNumber"
          name="newNumber"
          value={newNumber}
          placeholder="(00) 0000-00000"
          onValueChange={(values) => {
            const { value } = values;
            setNewNumber(value);
          }}
          format="(##) #####-####"
        />
      </fieldset>
      <fieldset>
        <label htmlFor="oldNumber">Número que deseja manter</label>
        <NumberFormat
          id="oldNumber"
          name="oldNumber"
          value={oldNumber}
          placeholder="(00) 0000-00000"
          onValueChange={(values) => {
            const { value } = values;
            setOldNumber(value);
          }}
          format="(##) #####-####"
        />
      </fieldset>
      <fieldset>
        <label htmlFor="operator">Operadora do número mantido</label>
        <select id="operator" onChange={(e) => setOperator(e.target.value)}>
          <option value="" selected disabled>
            Selecione a operadora
          </option>
          <option value="ALGAR">ALGAR</option>
          <option value="0307">AMERICANET MOVIL</option>
          <option value="0314">BRASIL TELECOM CELULAR</option>
          <option value="0321">CLARO</option>
          <option value="CORRE">CORREIOS</option>
          <option value="0312">CTBC</option>
          <option value="0301">DATORA</option>
          <option value="DSP_Code">DONOR</option>
          <option value="FUTCE">FUTCEL</option>
          <option value="GOSPE">GOSPEL</option>
          <option value="MAGAL">MAGALU</option>
          <option value="0351">NEXTEL</option>
          <option value="0331">OI</option>
          <option value="0302">PORTO CONECTA</option>
          <option value="0343">SERCOMTEL</option>
          <option value="0341">TIM</option>
          <option value="VEEK">VEEK</option>
          <option value="0320">VIVO</option>
        </select>
      </fieldset>
      <fieldset>
        <label htmlFor="cpf">CPF/CNPJ do titular das linhas</label>
        <NumberFormat
          id="cpf"
          name="cpf"
          value={cpf}
          placeholder="Digite o número do CPF"
          onValueChange={(values) => {
            const { value } = values;
            setCpf(value);
          }}
          format={cpf.length > 11 ? "##.###.###/####-##" : "###.###.###-###"}
        />
      </fieldset>
      <fieldset>
        <label htmlFor="name">Nome do titular das linhas</label>
        <input
          id="name"
          type="text"
          value={name}
          placeholder="Digite o nome"
          maxLength="50"
          className="name"
          onChange={(e) => setName(e.target.value)}
        />
      </fieldset>
      <button type="submit" className={`btn btn-default ${opacity1}`}>
        Enviar solicitação
      </button>
    </form>
  );
};

export default FormPortability;
